// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const DataTableWrapper = styled.div`
  // $blue in SCSS, aka primary color in bootstrap SCSS.
  border: thin solid #335c84;
  font-size: .9rem;
  max-height: 100%;
  min-height: 5em;
  overflow: auto;

  > table {
    min-width: ${props => props.minWidth || 0};
    table-layout: fixed;
    width: 100%;
  }
`

export const DataRowWrapper = styled.tr`
  border-bottom: thin solid #6c757d;

  &:nth-child(odd) {
    background-color: #fff;
  }

  &:nth-child(even) {
    // Kendo Grid's default 'alt' row bg color.
    background-color: rgb(225, 244, 253);
  }
`

export const DataHeadingWrapper = styled.th`
  // $blue in SCSS, aka primary color in bootstrap SCSS.
  background-color: #335c84;
  // first color comes from Kendo Grid's original styles
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08), 0 1px #fff, 0 2px #111;
  color: #fff;
  font-weight: normal;
  overflow: hidden;
  position: sticky;
  top: ${props => props.stickyTop || 0};
  white-space: nowrap;

  > div {
    align-items: center;
    display: flex;
    overflow: hidden;
    padding: .25em;

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

export const DataItemWrapper = styled.td`
  // default td color in Kendo Grid
  color: #656565;
  overflow: hidden;
  padding: .5em .25em;
  text-overflow: ellipsis;
  white-space: nowrap;

  & + & {
    // color comes from Kendo Grid's original styles
    border-left: thin solid rgba(0, 0, 0, 0.08);
  }

  &.deleted {
    background-color: red;
    color: #fff;
  }

  &.renewal-failed {
    background-color: rgb(255, 192, 192);
    text-shadow: 0 0 .125em white;
  }

  &.awaitingUserAction {
    background-color: purple;
    color: #fff;
  }
`
